import { RouteObject } from "react-router-dom";

import ErrorBoundary from "src/components/Errors/ErrorBoundary.tsx";
import { DashboardDetailPanelDisplay } from "src/pages/Reporting/DashboardDetailPanelDisplay";
import { DashboardListPanelDisplay } from "src/pages/Reporting/DashboardListPanelDisplay";

export const reportingRoutes: RouteObject[] = [
  {
    path: "/reporting",
    Component: DashboardListPanelDisplay,
    ErrorBoundary: ErrorBoundary,
  },
  {
    path: "/reporting/:dashboardId",
    Component: DashboardDetailPanelDisplay,
    ErrorBoundary: ErrorBoundary,
  },
];
